import { render, staticRenderFns } from "./TranslateEvent.vue?vue&type=template&id=59dc70f2&scoped=true&"
import script from "./TranslateEvent.vue?vue&type=script&lang=js&"
export * from "./TranslateEvent.vue?vue&type=script&lang=js&"
import style0 from "./TranslateEvent.vue?vue&type=style&index=0&id=59dc70f2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59dc70f2",
  null
  
)

export default component.exports